import { useRef } from "react"
import { LocomotiveScrollProvider } from "react-locomotive-scroll"
import { Outlet, useLocation } from "react-router-dom"

const LocomotiveProvider = () => {
  const location = useLocation()
  const containerRef = useRef(null)

  // useEffect(() => {
  //   if (!containerRef.current) return
  //   const scroll = new LocomotiveScroll({
  //     el: containerRef.current,
  //     smooth: true,
  //   })
  //   scroll.on("scroll", (instance) => {
  //     setSmall(instance.scroll.y > 50)
  //   })
  // }, [setSmall])

  return (
    <LocomotiveScrollProvider
      options={{
        smooth: true,
        repeat: true,
        getDirection: true,
      }}
      watch={[]}
      location={location.pathname}
      containerRef={containerRef}
      onLocationChange={(scroll) =>
        scroll.scrollTo(0, { duration: 0, disableLerp: true })
      }
      // onUpdate={(e) => console.log("Updated, but not on location change!")} // Will trigger on
    >
      <div data-scroll-container ref={containerRef}>
        <Outlet />
      </div>
    </LocomotiveScrollProvider>
  )
}

export default LocomotiveProvider
